var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_286_448081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 9.87538C9.37511 9.30249 9.5327 8.74066 9.83054 8.25129C10.1284 7.76191 10.555 7.36383 11.0639 7.10054C11.5726 6.83726 12.1441 6.7189 12.7155 6.75842C13.2871 6.79793 13.8368 6.9938 14.3045 7.3246C14.7722 7.6554 15.14 8.10841 15.3676 8.63412C15.5953 9.15983 15.6741 9.73801 15.5953 10.3055C15.5166 10.8729 15.2834 11.4078 14.9212 11.8517C14.5591 12.2955 14.0818 12.6313 13.5417 12.8222C13.2369 12.93 12.973 13.1296 12.7865 13.3936C12.5999 13.6576 12.4998 13.9729 12.5 14.2962V15.3441",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.25C12.2843 19.25 12.1094 19.0751 12.1094 18.8594C12.1094 18.6436 12.2843 18.4688 12.5 18.4688",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.25C12.7157 19.25 12.8906 19.0751 12.8906 18.8594C12.8906 18.6436 12.7157 18.4688 12.5 18.4688",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24.7187C18.9721 24.7187 24.2187 19.4721 24.2187 13C24.2187 6.52792 18.9721 1.28125 12.5 1.28125C6.02792 1.28125 0.78125 6.52792 0.78125 13C0.78125 19.4721 6.02792 24.7187 12.5 24.7187Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_286_448081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLarge);
export default __webpack_public_path__ + "static/media/InfoLarge.8fdc87765674e485765d6527ee56b3c2.svg";
export { ForwardRef as ReactComponent };